import React from 'react';
import { useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';
import { useTableState } from '@dotone/react-ui-core/hooks';
import { useCurrentUser, useShallowEqualSelector } from '@hooks';
import { fetchNetworkUsers } from '@actions';
import { NetworkUserFormModal } from '@dotone/react-ui-core';
import NetworkUserTable from './NetworkUserTable';
import NetworkUserForm from './NetworkUserForm';

const NetworkUserList = (props) => {
  const dispatch = useDispatch();
  const { currentUser } = useCurrentUser();
  const [tableProps, setTableProps] = useTableState();

  const { data, status, isLoading } = useShallowEqualSelector(
    ({ networkUserList }) => networkUserList
  );

  useDeepCompareEffect(() => {
    if (currentUser.id && !data.length && status !== 'success') {
      dispatch(fetchNetworkUsers());
    }
  }, [dispatch, currentUser.id, data.length, status]);

  return (
    <NetworkUserTable
      tableProps={tableProps}
      onTableChange={setTableProps}
      loading={isLoading}
      data={data}
      actions={
        <NetworkUserFormModal form={<NetworkUserForm />} buttonProps={{ className: 'mx-3 mt-3' }} />
      }
      {...props}
    />
  );
};

export default NetworkUserList;
